(function () {
    'use strict';

    function entityAdminEditsDataService($http, $q) {
        var baseUrl = '[BuildifyApiHost]/api/entityadminedits';
        var svc = this;
        svc.myProfileData = null;

        function loadAdminEntityEdits(entityId) {
            return $http.get(baseUrl + '/' + entityId).then(function (response) {
                return response.data;
            });
        };

        function updateAdminEntityEdits(entityId, entityAdminEdits) {
            return $http.put(baseUrl + '/' + entityId, entityAdminEdits).then(function (response) {
                return response.data;
            });
        };

        return {
            loadAdminEntityEdits: loadAdminEntityEdits,
            updateAdminEntityEdits: updateAdminEntityEdits
        }
    }

    entityAdminEditsDataService.$inject = ['$http', '$q'];

    angular.module('ecap.common').service('entityAdminEditsDataService', entityAdminEditsDataService);
})();